import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderDollar, renderFieldDisabled, renderCurrency, CustomCurrencyDisabled, CustomDollarDisabled } from '../../../../Utils/renderField/renderField';
import { renderField } from "../../../../Utils/renderField/renderField"
import { connect } from 'react-redux';
import { TYPE_OF_FLOW } from '../../../../../../utility/constants';
import { months } from '../../../../Utils/months';
import Swal from 'sweetalert2';
import { AddTransactionButtons, separateFieldsByType, renderSectionHeader, CurrencyDisplay, formatCurrency } from './CashFlowComponents';
const alerta = require('assets/img/icons/alerta_roja.png');

const TableRow = ({ system, index, fields, change, eliminar, currency }) => {
    const _months = months
    const is_manual = fields.get(index).is_manual;
    const isNew = fields.get(index).isNew;
    const isSalida = fields.get(index).type_of_flow === TYPE_OF_FLOW.SALIDAS;
    const currentRow = fields.get(index)

    React.useEffect(() => {
        change(`${system}.is_dollar`, currency === 'USD');
    }, [currency, system, change]);

    const delete_category = (index, id) => {
        let message = '¿Estás seguro de confirmar todos los cambios?';
        const SwalMod = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-primary btn-modal',
                cancelButton: 'btn btn-outline-dark mr-5 btn-modal',
                content: '',
                title: 'darck',
                popup: 'custom-modal-size',
            },
            buttonsStyling: false,
            showCloseButton: true,
            focusConfirm: false,
            focusCancel: false,
            padding: "1em",
        });

        SwalMod.fire({
            title: 'ADVERTENCIA',
            html: 'Si eliminas la categoría perderás toda la información, <br/>' + message,
            imageUrl: alerta,
            imageAlt: 'Alerta',
            showCancelButton: true,
            confirmButtonText: 'CONTINUAR',
            cancelButtonText: 'CANCELAR',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                fields.remove(index);
                eliminar(id)

            }
        });
    }

    const calculateTotalForRow = () => {
        const systemData = fields.get(index);
        if (!systemData) return 0;

        let totalForRow = _months.reduce((accumulatedTotal, month) => {
            const value = parseFloat(systemData[month]) || 0;
            accumulatedTotal += value;
            return accumulatedTotal;
        }, 0);
        return totalForRow;
    };

    // Estilos para salidas (texto rojo)
    const textStyle = isSalida ? { color: '#dc3545', fontWeight: '500' } : {};
    const cellStyle = { ...textStyle, width: "8%" };

    const handleClick = () => {
        if (isNew) {
            fields.remove(index);
        } else {
            delete_category(index, currentRow.id);
        }
    };

    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                <td className='first-column table-form-fixed-cell-left-0' style={{ minWidth: "250px" }}>
                    <Field
                        name={`${system}.name`}
                        type="text"
                        style={isSalida ? { color: '#dc3545', fontWeight: 'bold' } : {}}
                        component={is_manual ? renderField : renderFieldDisabled}
                        className="form-control"
                        placeholder='Nuevo'
                    />
                </td>
                <td className='table-form-fixed-cell-left-1 text-right-padded-sm' style={cellStyle}>
                    <CurrencyDisplay value={calculateTotalForRow(true)} currency={currency} isSalida={isSalida} />
                </td>
                {months.map((month) => (
                    <td key={month} style={{ width: "6.9%" }}>
                        <Field
                            name={`${system}.${month}`}
                            component={is_manual ? (currency === 'USD' ? renderDollar : renderCurrency) : (currency === 'USD' ? CustomDollarDisabled : CustomCurrencyDisabled)}
                            placeholder={fields.get(index).is_dollar ? '$ 0.00' : 'Q 0.00'}
                            disabled={!is_manual}
                            style={isSalida ? {
                                color: '#dc3545',
                                fontWeight: '500',
                                borderColor: '#dc3545',
                                backgroundColor: '#fff5f5'
                            } : {}}
                            isSalida={isSalida}
                            onBlur={(event) => {
                                // Obtener valor del estado Redux Form (más seguro)
                                let currentValue = parseFloat(fields.get(index)[month]) || 0;
                                
                                if (isSalida && currentValue > 0) {
                                    currentValue = -currentValue;
                                    change(`${system}.${month}`, currentValue);
                                }
                                
                                calculateTotalForRow();
                            }}
                        />
                    </td>
                ))}

                <td className="text-center sin-borde-top">
                    {is_manual && <div>
                        <img src={require('assets/img/icons/Accion-Eliminar.svg')} alt="Borrar"
                            title="Borrar" className="action_img"

                            onClick={handleClick}
                        />
                    </div>
                    }
                </td>

            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, dollar_exchange, allValues, change, eliminar, currency }) => {
    const [collapsed, setCollapsed] = React.useState(false);

    const calculateTotalForMonth = (month, isDollar) => {
        const allFields = fields.getAll() || [];
        let total = allFields.reduce((total, system) => {
            let value = parseFloat(system[month]) || 0;
            if (system.isTitulo) {
                return total
            }
            
            return total + value;

        }, 0);
        
        return total;
    };

    const { ingresos, salidas } = separateFieldsByType(fields);

    const columnas = Array.from({ length: 12 }, (_, index) => (
        <th key={index} style={{ width: "6.9%" }}>{index + 1}</th>
    ));

    return (
        <div className=" col-sm-12 form-group np-r p-0">
            <div className='table-responsive'>
                <table className="table table-striped mb-0">
                    <thead onClick={() => setCollapsed(!collapsed)} style={{ cursor: 'pointer' }}>
                        <tr>
                            <th className='first-column table-form-fixed-cell-left-0 titulo-left-padded' style={{ color: "#2d5016" }}>
                            <div className="d-flex align-items-center">
                                <span className="mr-2" style={{ fontSize: '14px' }}>
                                    {collapsed ? '▶' : '▼'}
                                </span>
                                FLUJOS OPERATIVOS
                            </div>
                        </th>
                            
                                <th className='table-form-fixed-cell-left-1 text-right-padded-sm'>TOTAL</th>
                                {columnas}
                                <th>ACCIONES</th>
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: "#F0FFC7" }}>
                            {!collapsed && (
                                <React.Fragment>
                                    {fields.getAll() && fields.getAll().map((field, index) => {
                                        if (field.isTitulo) {
                                            return (
                                                <TableRow
                                                    key={`titulo-${index}`}
                                                    system={`operation.${index}`}
                                                    index={index}
                                                    fields={fields}
                                                    change={change}
                                                    eliminar={eliminar}
                                                    currency={currency} />
                                            );
                                        }
                                        return null;
                                    })}

                                    {ingresos.length > 0 && renderSectionHeader('INGRESOS', '#d4edda', ingresos, currency)}
                                    {ingresos.map(({ field, index }) =>
                                        <TableRow
                                            key={`ingreso-${index}`}
                                            system={`operation.${index}`}
                                            index={index}
                                            fields={fields}
                                            change={change}
                                            currency={currency}
                                            eliminar={eliminar} />
                                    )}
                                    
                                    {salidas.length > 0 && renderSectionHeader('SALIDAS', '#f8d7da', salidas, currency)}
                                    {salidas.map(({ field, index }) =>
                                        <TableRow
                                            key={`salida-${index}`}
                                            system={`operation.${index}`}
                                            index={index}
                                            fields={fields}
                                            change={change}
                                            currency={currency}
                                            eliminar={eliminar} />
                                    )}
                                </React.Fragment>
                            )}
                            {collapsed && (
                                <React.Fragment>
                                    {fields.getAll() && fields.getAll().map((field, index) => {
                                        if (field.isTitulo) {
                                            return (
                                                <TableRow
                                                    key={`titulo-collapsed-${index}`}
                                                    system={`operation.${index}`}
                                                    index={index}
                                                    fields={fields}
                                                    change={change}
                                                    eliminar={eliminar}
                                                    currency={currency} />
                                            );
                                        }
                                        return null;
                                    })}
                                    {ingresos.length > 0 && renderSectionHeader('INGRESOS', '#d4edda', ingresos, currency)}
                                    {salidas.length > 0 && renderSectionHeader('SALIDAS', '#f8d7da', salidas, currency)}
                                </React.Fragment>
                            )}

                            {currency !== 'USD' ?
                                (<tr className="celda-totales">
                                    <td className='table-form-fixed-cell-left-0 titulo-left-padded'>DIFERENCIA Q</td>
                                    <td className='table-form-fixed-cell-left-1 text-right-padded'>
                                        {formatCurrency(calculateTotalForMonth('total'), currency, calculateTotalForMonth('total') < 0)}
                                    </td>
                                    {months.map((month, idx) => (
                                        <td key={idx} className='text-right-padded'>
                                            {formatCurrency(calculateTotalForMonth(month), currency, calculateTotalForMonth(month) < 0)}
                                        </td>
                                    ))}
                                    <td></td>
                                </tr>)
                                :
                                (
                                    <tr className="celda-totales">
                                        <td className='table-form-fixed-cell-left-0 titulo-left-padded'>DIFERENCIA $</td>
                                        <td className='table-form-fixed-cell-left-1 text-right-padded'>
                                            {formatCurrency(calculateTotalForMonth('total'), currency, calculateTotalForMonth('total') < 0)}
                                        </td>
                                        {months.map((month, idx) => (
                                            <td key={idx} className='text-right-padded'>
                                                {formatCurrency(calculateTotalForMonth(month), currency, calculateTotalForMonth(month) < 0)}
                                            </td>
                                        ))}
                                        <td></td>
                                    </tr>)
                            }


                        </tbody>
                    </table>

            </div>
            {!collapsed && (
                <AddTransactionButtons 
                fields={fields} 
                setCollapsed={setCollapsed} 
                transactionType="OPERATING" 
            />)}
            
        </div>
    );
}

const OperatingFlowDetailTable = ({ dollar_exchange, allValues, change, eliminar, currency }) => {

    return (
        <div>
            <FieldArray
                name={`operation`}
                dollar_exchange={dollar_exchange}
                component={GenericTable}
                allValues={allValues}
                change={change}
                eliminar={eliminar}
                currency={currency}
            />
        </div>
    );
}

const formName = 'CashFlowForm';

const mapStateToProps = (state) => {
    // Obtener todos los valores del formulario directamente
    const formValues = state.form.CashFlowForm && state.form.CashFlowForm.values || {};
    
    return { 
        allValues: {
            operation: formValues.operation || [],
            financial: formValues.financial || [],
            investments: formValues.investments || { results: [] },
            summary: formValues.summary || []
        }
    };
};

export default connect(mapStateToProps)(OperatingFlowDetailTable);
